module.exports = __webpack_public_path__ + "img/product_xd_2.425e52de.jpg";